pageLoad('storages_index', () => {
  if (!document.querySelector('.storages-v4-index')) { return; }

  $('a.read-more').on('click', ({ currentTarget }) => {
    const $parent = $(currentTarget).parent();

    $parent.next('.spoiler').children().unwrap();
    $(currentTarget).remove();

    if ($parent.is(':empty')) {
      $parent.remove();
    }
  });
});
